module.exports = __webpack_public_path__ + "static/grafika2@2x-f363accdbe96e66446820471a6e8e6db.png";